import { User } from './models/User'
import {Channel} from './models/Channel'
import Workspace from './models/Workspace'
import Subject from './models/Subject'
import {
  Material, MaterialType, MaterialCategory, MaterialAppearance, MaterialGroup
} from './models/Material'
import { FixedJournalList } from './models/FixedJournal'

export default {
  isAdministrable(state) {
    return state.credentials ? state.credentials.user_administrable : null
  },
  currentUserId(state) {
    return state.credentials ? state.credentials.user_id : null
  },
  getUserRole(state) {
    return (channelId) => {
      return state.credentials ? state.credentials.user_roles[channelId] : false
    }
  },
  isReadable(state) {
    return (channelId) => {
      if (state.credentials && state.credentials.user_administrable) {
        return true
      }

      return state.credentials ? ['guest', 'viewer', 'editor', 'manager', 'director'].includes(state.credentials.user_roles[channelId]) : false
    }
  },
  isWritable(state) {
    return (channelId) => {
      if (state.credentials && state.credentials.user_administrable) {
        return true
      }

      return state.credentials ? ['editor', 'manager', 'director'].includes(state.credentials.user_roles[channelId]) : false
    }
  },
  isManageable(state) {
    return (channelId) => {
      if (state.credentials && state.credentials.user_administrable) {
        return true
      }

      return state.credentials ? ['manager', 'director'].includes(state.credentials.user_roles[channelId]) : null
    }
  },
  users(context) {
    return User.query().withAllRecursive().all()
  },
  materialCategories(context) {
    return MaterialCategory.query().withAllRecursive().orderBy(i => i.order).all()
  },
  materialAppearances(context) {
    return MaterialAppearance.query().withAllRecursive().orderBy(i => i.order).all()
  },
  materialTypes(context) {
    return MaterialType.query().withAllRecursive().orderBy(i => i.order).all()
  },
  materialGroups(context) {
    return MaterialGroup.query().withAllRecursive().all()
  },
  materials(context) {
    return Material.query().withAllRecursive().orderBy(i => i.order).all()
  },
  getMaterialCategory(context) {
    return (materialCategoryId) => {
      return MaterialCategory
        .query()
        .withAllRecursive()
        .find(materialCategoryId)
    }
  },
  getMaterialAppearance(context) {
    return (materialAppearanceId) => {
      return MaterialAppearance
        .query()
        .withAllRecursive()
        .find(materialAppearanceId)
    }
  },
  getWorkspace(context) {
    return ({channelId, workspaceId}) => {
      return Workspace
        .query()
        .where('id', workspaceId)
        .where('channel_id', channelId)
        .withAllRecursive()
        .first()
    }
  },
  getMaterialByJournalId(context) {
    return (journalId) => {
      return Material.all().filter(i => i.journal && i.journal.id == journalId)
    }
  },
  listSubject(context) {
    return ({channelId, workspaceId, prefs, kinds}) => {
      return Subject
        .query()
        .where('channel_id', channelId)
        .where('workspace_id', workspaceId)
        .where('tags', (tags) => {
          if (prefs.length == 0) {
            return true
          }
          return tags.filter(i => prefs.includes(i)).length > 0
        })
        .where('tags', (tags) => {
          if (kinds.length == 0) {
            return true
          }
          return tags.filter(i => kinds.includes(i)).length > 0
        })
        .withAllRecursive()
        .orderBy('modified_at', 'desc')
        .all()
    }
  },
  channels(context) {
    return Channel.query().with('workspaces', (i) => i.orderBy('name')).all()
  },
  fixedJournalLists(context) {
    return FixedJournalList.query().withAllRecursive().all()
  }
}
